// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr > * {
  color: white !important;
  font-family: 'Roboto Mono', monospace !important;
}

.false {
  color: rgb(239, 94, 94) !important;
}

thead > tr > th {
  background-color: rgb(42, 42, 43) !important;
  font-family: 'Roboto Mono', monospace !important;
  font-weight: 500 !important;
  font-size: 1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/components/systemcontrol/system-logs.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,2BAA2B;EAC3B,0BAA0B;AAC5B","sourcesContent":["tr > * {\n  color: white !important;\n  font-family: 'Roboto Mono', monospace !important;\n}\n\n.false {\n  color: rgb(239, 94, 94) !important;\n}\n\nthead > tr > th {\n  background-color: rgb(42, 42, 43) !important;\n  font-family: 'Roboto Mono', monospace !important;\n  font-weight: 500 !important;\n  font-size: 1rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
